import React from "react";
import PropTypes from "prop-types";
import ClickTooltip from "../../atoms/Tooltip/ClickTooltip";

function UserTitle({
  resolvedUser,
  isCoAuthor,
  defaultName,
  isSaphetorCuratorLinked,
}) {
  const {
    first_name: firstName,
    last_name: lastName,
    screen_name: screenName,
    organisation_public: isPublic,
    organisation,
  } = resolvedUser || {};
  const {
    local_language_name: orgLang,
    organisation_name: orgName,
    uri: orgURL,
    country,
  } = organisation || {};

  const { country: countryName } = country || {};
  const name = [firstName, lastName].filter(Boolean).join(" ");
  const profilePage = screenName ? `/profile/@${screenName}` : null;
  const profileName = name || screenName || defaultName;

  return (
    <div className="tw-inline-block">
      {isSaphetorCuratorLinked ? (
        <span className="tw-bg-sky-500 tw-text-white tw-mr-2 tw-py-px tw-px-1 tw-rounded tw-text-sm tw-font-bold">
          VarSome Curator
        </span>
      ) : null}

      {isCoAuthor ? (
        <i
          data-tooltip="User has declared they are a co-author of the publication."
          className="fa fa-star tw-pr-1"
          data-tooltip-delay={700}
          data-tooltip-class="publications-tooltip"
        />
      ) : null}

      {isPublic ? (
        <ClickTooltip
          className="publications-tooltip"
          ContentRenderer={() => (
            <div className="tw-text-blueGray-700 tw-p-2 tw-text-sm tw-pointer-events-auto">
              <div className="tw-text-base tw-font-semibold">{name}</div>
              {screenName ? (
                <div className="tw-flex">
                  <div className="tw-w-32">User Profile</div>
                  <a href={profilePage} target="_blank">
                    @{screenName}
                  </a>
                </div>
              ) : null}
              {orgName ? (
                <div className="tw-flex">
                  <div className="tw-w-32">Organisation</div>
                  <div>
                    {orgURL ? (
                      <a href={orgURL} target="_blank" rel="noreferrer">
                        {orgName || orgURL}
                      </a>
                    ) : null}
                    {orgName && !orgURL ? orgName : null}
                  </div>
                </div>
              ) : null}
              {orgLang ? (
                <div className="tw-flex">
                  <div className="tw-w-32">Language</div>
                  <div>{orgLang}</div>
                </div>
              ) : null}
              {countryName ? (
                <div className="tw-flex">
                  <div className="tw-w-32">Country</div>
                  <div>{countryName}</div>
                </div>
              ) : null}
            </div>
          )}
        >
          <span className="tw-font-bold tw-cursor-pointer hover:tw-underline">
            {profileName}
          </span>
        </ClickTooltip>
      ) : (
        profileName
      )}
    </div>
  );
}

UserTitle.propTypes = {
  defaultName: PropTypes.string,
  resolvedUser: PropTypes.shape({}),
  isCoAuthor: PropTypes.bool,
  isSaphetorCuratorLinked: PropTypes.bool,
};

UserTitle.defaultProps = {
  defaultName: "Varsome User",
  resolvedUser: null,
  isCoAuthor: false,
  isSaphetorCuratorLinked: false,
};

export default React.memo(UserTitle);
